import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CargaZEDto;
import { columnas } from "./columns";
const resource = resources.CargaZE;
interface props {
    idChofer: number | undefined;
    Session: models.Session;
}

class CargaZEListNoRX extends React.PureComponent<props> {
    modalManager = kea.createModalManager();

    idChofer = (x: props) => x.idChofer;
    noTieneChofer = createSelectorRx(this.idChofer, idChofer => idChofer == undefined);

    items = observeResource(  resources.CargaZE.query)

    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);

    onDelete = async (x: Entity) => {
        if (await kea.yesno("¿Eliminar carga de zona extendida?", "" + x.Folio)) {
            await resource.delete(x.IdRegistro);
            await kea.message("La carga de zona extendida ha sido eliminada");
        }
    }

    onCerrar = async (x: Entity) => {
        if (await kea.yesno("¿Finaliza carga de zona extendida?", "" + x.Folio)) {
            await resource.FinalizarCarga(x.IdRegistro);
            await kea.message("La carga de zona extendida ha sido finalizada");
        }
    }

    onAgregar = async () => {

        var ccc = await this.modalManager.showModal(SolucionesEnrutamientoModal, undefined, null );
        var idChofer = ccc.value?.IdChofer == null ? 0 : ccc.value.IdChofer
        if (idChofer > 0) {
            if ( this.props.Session.Permisos.CargaZE.Iniciar ) {
                var idNuevo = await resources.CargaZE.IniciarCargaZE( idChofer );
                history.go(`./${idNuevo}`);
            } else {
                await kea.message("No tiene Permisos", "Debe tener permisos de iniciar carga en zona extendida", "error");
            }
        }
    }

    onRegresar = () => history.go('../');

    render() {
        const noTieneChofer = this.noTieneChofer(this.props);
        const cols = columnas(this, this.props.Session.Permisos);
        
        return (
            <div>
                <kea.Title titulo="Cargas de zona extendida" onRegresar={this.onRegresar}>
                    {
                        this.props.Session.Permisos.CargaZE.Iniciar &&
                        <kea.AgregarButton onClick={this.onAgregar} />
                    }
                </kea.Title>
                <kea.Grid2 columnas={cols} cookieKey={"CargaZEListCookieKey"} items={this.items} />
                {this.modalManager.component}
            </div>
        )
    }
}

const CargaZEListRX = componentToRx(CargaZEListNoRX);
export class CargaZEList extends React.PureComponent {
    session = () => resources.User.SessionRx;
    idChoferZE = createSelectorRx(this.session, session => (session.IdChoferZE || undefined));

    render() {
        const idChoferZE = this.idChoferZE(this.props);
        return (
            <CargaZEListRX idChofer={idChoferZE} Session={resources.User.SessionRx} />
        )
    }
}


type Entity2 = models.FiltroCrearCargaZE;

interface ModalProps extends kea.ModalProps<Entity2, Entity2|null, undefined> {
}

export function validar(x: Entity2) {
    const rules: validation.Rules<Entity2> = {
        IdChofer : validation.required
    };
    return validation.getErrors(rules, x);
}

class SolucionesEnrutamientoModal extends React.PureComponent<ModalProps> {
    value = (props: Entity2) => props;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = formfields(() => this.props, () => this.errors(this.props.value));

    onCerrar = () => {
        //.props.value.IdChofer = 0
        if (this.props.value != null) {
            this.props.value.IdChofer = 0
        }
        this.props.onClose(this.props.value);
    }

    render() {
        const value = this.props.value  ;
        const Proveedor = this.getField(selectores.UsuarioZEByUserRol);
        const ValueNull = value == null;
        const ChoferZE = this.getField(selectores.ChoferZEByUserZE ( ValueNull ? 0 : ( value.IdProveedor == null ? 0 : value.IdProveedor )  ));
        return (
            <kea.Modal
                onClose={this.onCerrar}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(null)}  disabled={validation.hasError(this.errors(this.props.value))} />
                ]}
                title="Crear Inicio de carga"
            >
                {kea.autogrid(3, [
                    <Proveedor field="IdProveedor" label="Proveedor" />,
                    <ChoferZE field="IdChofer" label="Chofer" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/list/list.tsx